import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page4 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="react-print2-none">
                                                <ReactToPrint
                                                    trigger={() => <div className={'d-flex justify-content-end'}>
                                                        <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                    </div>}
                                                    content={ () => {
                                                        let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                        let div1 = document.createElement('div');
                                                        div1.className = 'ilead-tools-pages';
                                                        div1.appendChild(html);

                                                        let div2 = document.createElement('div');
                                                        div2.className = 'ilead-tools-body react-print1';
                                                        div2.appendChild(div1);

                                                        return div2.cloneNode(true);
                                                    }}
                                                />

                                                <div className="circle_title"><img
                                                    src={require('@images/Browndot.png')}
                                                    alt=""/>YOUR CAREER ANALYSIS CHART
                                                </div>
                                                <div className="innovativeimg">

                                                    <img
                                                        src={require('@images/graph_yourself1.png')}
                                                        alt=""/>

                                                </div>
                                            </div>

                                            <div className="react-print1-none">
                                                <div className="circle_title"><img
                                                    src={require('@images/Browndot.png')}
                                                    alt=""/>UNCOVERING SIGNATURE STRENGTHS
                                                </div>
                                                <p>The last task should have helped you identify some of your most
                                                    inspirational and not-so-inspirational
                                                    moments at work. Hopefully you will have noticed some trends of
                                                    what it is that you
                                                    feel that you excel at, and what you might struggle with. Also,
                                                    the kind of work that you enjoy and
                                                    spurs you on, and what drains you and leaves you feeling
                                                    unsatisfied.</p>
                                                <p>We will now start focusing on the positives. Being aware of your
                                                    strengths means you can take on
                                                    tasks with the ball in your court and bring out your best
                                                    performance.</p>
                                                <p>First of all, decide which, on the Career Analysis list below,
                                                    are really your key strengths, and then
                                                    number them 1-6. There don’t have to be 6 – pick the right
                                                    number for you based on the last
                                                    exercise. For each strength you’ve listed, tick off any or all
                                                    of the statements that were relevant
                                                    when you used them.<a className="superscripttext"
                                                                          href="further_info.php?course=300"><sup>4</sup></a>
                                                </p>

                                                <ReactToPrint
                                                    trigger={() => <div className={'d-flex justify-content-end'}>
                                                        <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                    </div>}
                                                    content={ () => {
                                                        let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                        let div1 = document.createElement('div');
                                                        div1.className = 'ilead-tools-pages';
                                                        div1.appendChild(html);

                                                        let div2 = document.createElement('div');
                                                        div2.className = 'ilead-tools-body react-print2';
                                                        div2.appendChild(div1);

                                                        return div2.cloneNode(true);
                                                    }}
                                                />

                                                <br/>
                                                <div className="mobile-scroll">
                                                    <table width="100%" border="0" cellSpacing="0"
                                                           cellPadding="0"
                                                           className="ilead_v_sport  tablesrink ilead_v_sport_center ilead_v_sport_centerth">
                                                        <tbody>
                                                        <tr>
                                                            <th width="35%" align="left" valign="top"
                                                                className="green_curve"></th>

                                                            <th width="8%" align="center" valign="center">1</th>
                                                            <th width="8%" align="center" valign="center">2</th>
                                                            <th width="8%" align="center" valign="center">3</th>
                                                            <th width="8%" align="center" valign="center">4</th>
                                                            <th width="8%" align="center" valign="center">5</th>
                                                            <th width="8%" align="center" valign="center"
                                                                className=" green_curve1">6
                                                            </th>
                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className=" darkgreen uiheading">
                                                                <div className="paraspace paratop"><p>I feel a
                                                                    sense of authenticity, like this is the real
                                                                    me.</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="IFeelASenseOfAuthenticityLikeThisIsTheRealMe1"
                                                                       onChange={this.props.handleChangePageData('IFeelASenseOfAuthenticityLikeThisIsTheRealMe', true)}
                                                                       checked={pageData?.IFeelASenseOfAuthenticityLikeThisIsTheRealMe?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelASenseOfAuthenticityLikeThisIsTheRealMe1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="IFeelASenseOfAuthenticityLikeThisIsTheRealMe2"
                                                                       onChange={this.props.handleChangePageData('IFeelASenseOfAuthenticityLikeThisIsTheRealMe', true)}
                                                                       checked={pageData?.IFeelASenseOfAuthenticityLikeThisIsTheRealMe?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelASenseOfAuthenticityLikeThisIsTheRealMe2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="IFeelASenseOfAuthenticityLikeThisIsTheRealMe3"
                                                                       onChange={this.props.handleChangePageData('IFeelASenseOfAuthenticityLikeThisIsTheRealMe', true)}
                                                                       checked={pageData?.IFeelASenseOfAuthenticityLikeThisIsTheRealMe?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelASenseOfAuthenticityLikeThisIsTheRealMe3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="IFeelASenseOfAuthenticityLikeThisIsTheRealMe4"
                                                                       onChange={this.props.handleChangePageData('IFeelASenseOfAuthenticityLikeThisIsTheRealMe', true)}
                                                                       checked={pageData?.IFeelASenseOfAuthenticityLikeThisIsTheRealMe?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelASenseOfAuthenticityLikeThisIsTheRealMe4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="IFeelASenseOfAuthenticityLikeThisIsTheRealMe5"
                                                                       onChange={this.props.handleChangePageData('IFeelASenseOfAuthenticityLikeThisIsTheRealMe', true)}
                                                                       checked={pageData?.IFeelASenseOfAuthenticityLikeThisIsTheRealMe?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelASenseOfAuthenticityLikeThisIsTheRealMe5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="IFeelASenseOfAuthenticityLikeThisIsTheRealMe6"
                                                                       onChange={this.props.handleChangePageData('IFeelASenseOfAuthenticityLikeThisIsTheRealMe', true)}
                                                                       checked={pageData?.IFeelASenseOfAuthenticityLikeThisIsTheRealMe?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelASenseOfAuthenticityLikeThisIsTheRealMe6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className="lightgreen uiheading">
                                                                <div className="paraspace paratop"><p>I feel
                                                                    excitement while displaying it.</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="IFeelExcitementWhileDisplayingIt1"
                                                                       onChange={this.props.handleChangePageData('IFeelExcitementWhileDisplayingIt', true)}
                                                                       checked={pageData?.IFeelExcitementWhileDisplayingIt?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelExcitementWhileDisplayingIt1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="IFeelExcitementWhileDisplayingIt2"
                                                                       onChange={this.props.handleChangePageData('IFeelExcitementWhileDisplayingIt', true)}
                                                                       checked={pageData?.IFeelExcitementWhileDisplayingIt?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelExcitementWhileDisplayingIt2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="IFeelExcitementWhileDisplayingIt3"
                                                                       onChange={this.props.handleChangePageData('IFeelExcitementWhileDisplayingIt', true)}
                                                                       checked={pageData?.IFeelExcitementWhileDisplayingIt?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelExcitementWhileDisplayingIt3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="IFeelExcitementWhileDisplayingIt4"
                                                                       onChange={this.props.handleChangePageData('IFeelExcitementWhileDisplayingIt', true)}
                                                                       checked={pageData?.IFeelExcitementWhileDisplayingIt?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelExcitementWhileDisplayingIt4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="IFeelExcitementWhileDisplayingIt5"
                                                                       onChange={this.props.handleChangePageData('IFeelExcitementWhileDisplayingIt', true)}
                                                                       checked={pageData?.IFeelExcitementWhileDisplayingIt?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelExcitementWhileDisplayingIt5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="IFeelExcitementWhileDisplayingIt6"
                                                                       onChange={this.props.handleChangePageData('IFeelExcitementWhileDisplayingIt', true)}
                                                                       checked={pageData?.IFeelExcitementWhileDisplayingIt?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelExcitementWhileDisplayingIt6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className=" darkgreen uiheading">
                                                                <div className="paraspace paratop"><p>There was
                                                                    a rapid learning curve when my strength was
                                                                    first practiced.</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="ThereWasARapidLearningCurve1"
                                                                       onChange={this.props.handleChangePageData('ThereWasARapidLearningCurve', true)}
                                                                       checked={pageData?.ThereWasARapidLearningCurve?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="ThereWasARapidLearningCurve1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="ThereWasARapidLearningCurve2"
                                                                       onChange={this.props.handleChangePageData('ThereWasARapidLearningCurve', true)}
                                                                       checked={pageData?.ThereWasARapidLearningCurve?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="ThereWasARapidLearningCurve2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="ThereWasARapidLearningCurve3"
                                                                       onChange={this.props.handleChangePageData('ThereWasARapidLearningCurve', true)}
                                                                       checked={pageData?.ThereWasARapidLearningCurve?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="ThereWasARapidLearningCurve3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="ThereWasARapidLearningCurve4"
                                                                       onChange={this.props.handleChangePageData('ThereWasARapidLearningCurve', true)}
                                                                       checked={pageData?.ThereWasARapidLearningCurve?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="ThereWasARapidLearningCurve4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="ThereWasARapidLearningCurve5"
                                                                       onChange={this.props.handleChangePageData('ThereWasARapidLearningCurve', true)}
                                                                       checked={pageData?.ThereWasARapidLearningCurve?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="ThereWasARapidLearningCurve5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="ThereWasARapidLearningCurve6"
                                                                       onChange={this.props.handleChangePageData('ThereWasARapidLearningCurve', true)}
                                                                       checked={pageData?.ThereWasARapidLearningCurve?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="ThereWasARapidLearningCurve6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className="lightgreen uiheading">
                                                                <div className="paraspace paratop"><p>I yearn to
                                                                    find new ways to use it.</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="IYearnToFindNewWaysToUseIt1"
                                                                       onChange={this.props.handleChangePageData('IYearnToFindNewWaysToUseIt', true)}
                                                                       checked={pageData?.IYearnToFindNewWaysToUseIt?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="IYearnToFindNewWaysToUseIt1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="IYearnToFindNewWaysToUseIt2"
                                                                       onChange={this.props.handleChangePageData('IYearnToFindNewWaysToUseIt', true)}
                                                                       checked={pageData?.IYearnToFindNewWaysToUseIt?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="IYearnToFindNewWaysToUseIt2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="IYearnToFindNewWaysToUseIt3"
                                                                       onChange={this.props.handleChangePageData('IYearnToFindNewWaysToUseIt', true)}
                                                                       checked={pageData?.IYearnToFindNewWaysToUseIt?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="IYearnToFindNewWaysToUseIt3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="IYearnToFindNewWaysToUseIt4"
                                                                       onChange={this.props.handleChangePageData('IYearnToFindNewWaysToUseIt', true)}
                                                                       checked={pageData?.IYearnToFindNewWaysToUseIt?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="IYearnToFindNewWaysToUseIt4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="IYearnToFindNewWaysToUseIt5"
                                                                       onChange={this.props.handleChangePageData('IYearnToFindNewWaysToUseIt', true)}
                                                                       checked={pageData?.IYearnToFindNewWaysToUseIt?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="IYearnToFindNewWaysToUseIt5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="IYearnToFindNewWaysToUseIt6"
                                                                       onChange={this.props.handleChangePageData('IYearnToFindNewWaysToUseIt', true)}
                                                                       checked={pageData?.IYearnToFindNewWaysToUseIt?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="IYearnToFindNewWaysToUseIt6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className=" darkgreen uiheading">
                                                                <div className="paraspace paratop"><p>I feel
                                                                    that using my strength is inevitable,just
                                                                    try and stop me!</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="IFeelThatIsingMyStrengthIsInevitable1"
                                                                       onChange={this.props.handleChangePageData('IFeelThatIsingMyStrengthIsInevitable', true)}
                                                                       checked={pageData?.IFeelThatIsingMyStrengthIsInevitable?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelThatIsingMyStrengthIsInevitable1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="IFeelThatIsingMyStrengthIsInevitable2"
                                                                       onChange={this.props.handleChangePageData('IFeelThatIsingMyStrengthIsInevitable', true)}
                                                                       checked={pageData?.IFeelThatIsingMyStrengthIsInevitable?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelThatIsingMyStrengthIsInevitable2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="IFeelThatIsingMyStrengthIsInevitable3"
                                                                       onChange={this.props.handleChangePageData('IFeelThatIsingMyStrengthIsInevitable', true)}
                                                                       checked={pageData?.IFeelThatIsingMyStrengthIsInevitable?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelThatIsingMyStrengthIsInevitable3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="IFeelThatIsingMyStrengthIsInevitable4"
                                                                       onChange={this.props.handleChangePageData('IFeelThatIsingMyStrengthIsInevitable', true)}
                                                                       checked={pageData?.IFeelThatIsingMyStrengthIsInevitable?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelThatIsingMyStrengthIsInevitable4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="IFeelThatIsingMyStrengthIsInevitable5"
                                                                       onChange={this.props.handleChangePageData('IFeelThatIsingMyStrengthIsInevitable', true)}
                                                                       checked={pageData?.IFeelThatIsingMyStrengthIsInevitable?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelThatIsingMyStrengthIsInevitable5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="IFeelThatIsingMyStrengthIsInevitable6"
                                                                       onChange={this.props.handleChangePageData('IFeelThatIsingMyStrengthIsInevitable', true)}
                                                                       checked={pageData?.IFeelThatIsingMyStrengthIsInevitable?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelThatIsingMyStrengthIsInevitable6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className="lightgreen uiheading">
                                                                <div className="paraspace paratop"><p>I feel
                                                                    invigorated rather than exhausted while
                                                                    using my strength.</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="IFeelInvigoratedRatherThanExhausted1"
                                                                       onChange={this.props.handleChangePageData('IFeelInvigoratedRatherThanExhausted', true)}
                                                                       checked={pageData?.IFeelInvigoratedRatherThanExhausted?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelInvigoratedRatherThanExhausted1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="IFeelInvigoratedRatherThanExhausted2"
                                                                       onChange={this.props.handleChangePageData('IFeelInvigoratedRatherThanExhausted', true)}
                                                                       checked={pageData?.IFeelInvigoratedRatherThanExhausted?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelInvigoratedRatherThanExhausted2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="IFeelInvigoratedRatherThanExhausted3"
                                                                       onChange={this.props.handleChangePageData('IFeelInvigoratedRatherThanExhausted', true)}
                                                                       checked={pageData?.IFeelInvigoratedRatherThanExhausted?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelInvigoratedRatherThanExhausted3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="IFeelInvigoratedRatherThanExhausted4"
                                                                       onChange={this.props.handleChangePageData('IFeelInvigoratedRatherThanExhausted', true)}
                                                                       checked={pageData?.IFeelInvigoratedRatherThanExhausted?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelInvigoratedRatherThanExhausted4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="IFeelInvigoratedRatherThanExhausted5"
                                                                       onChange={this.props.handleChangePageData('IFeelInvigoratedRatherThanExhausted', true)}
                                                                       checked={pageData?.IFeelInvigoratedRatherThanExhausted?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelInvigoratedRatherThanExhausted5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="IFeelInvigoratedRatherThanExhausted6"
                                                                       onChange={this.props.handleChangePageData('IFeelInvigoratedRatherThanExhausted', true)}
                                                                       checked={pageData?.IFeelInvigoratedRatherThanExhausted?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelInvigoratedRatherThanExhausted6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className=" darkgreen uiheading">
                                                                <div className="paraspace paratop"><p>I tend to
                                                                    pursue personal projects that revolve around
                                                                    my strength.</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="ITendToPursuePersonalProjects1"
                                                                       onChange={this.props.handleChangePageData('ITendToPursuePersonalProjects', true)}
                                                                       checked={pageData?.ITendToPursuePersonalProjects?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="ITendToPursuePersonalProjects1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="ITendToPursuePersonalProjects2"
                                                                       onChange={this.props.handleChangePageData('ITendToPursuePersonalProjects', true)}
                                                                       checked={pageData?.ITendToPursuePersonalProjects?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="ITendToPursuePersonalProjects2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="ITendToPursuePersonalProjects3"
                                                                       onChange={this.props.handleChangePageData('ITendToPursuePersonalProjects', true)}
                                                                       checked={pageData?.ITendToPursuePersonalProjects?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="ITendToPursuePersonalProjects3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="ITendToPursuePersonalProjects4"
                                                                       onChange={this.props.handleChangePageData('ITendToPursuePersonalProjects', true)}
                                                                       checked={pageData?.ITendToPursuePersonalProjects?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="ITendToPursuePersonalProjects4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="ITendToPursuePersonalProjects5"
                                                                       onChange={this.props.handleChangePageData('ITendToPursuePersonalProjects', true)}
                                                                       checked={pageData?.ITendToPursuePersonalProjects?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="ITendToPursuePersonalProjects5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className=" darkgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="ITendToPursuePersonalProjects6"
                                                                       onChange={this.props.handleChangePageData('ITendToPursuePersonalProjects', true)}
                                                                       checked={pageData?.ITendToPursuePersonalProjects?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="ITendToPursuePersonalProjects6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        <tr>

                                                            <td width="35%" align="left" valign="center"
                                                                className="lightgreen uiheading">
                                                                <div className="paraspace paratop"><p>I feel
                                                                    joy, zest, enthusiasm, and maybe even
                                                                    ecstasy while using my strength.</p></div>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="1"
                                                                       id="IFeelJoy1"
                                                                       onChange={this.props.handleChangePageData('IFeelJoy', true)}
                                                                       checked={pageData?.IFeelJoy?.[1]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelJoy1">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="2"
                                                                       id="IFeelJoy2"
                                                                       onChange={this.props.handleChangePageData('IFeelJoy', true)}
                                                                       checked={pageData?.IFeelJoy?.[2]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelJoy2">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="3"
                                                                       id="IFeelJoy3"
                                                                       onChange={this.props.handleChangePageData('IFeelJoy', true)}
                                                                       checked={pageData?.IFeelJoy?.[3]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelJoy3">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="4"
                                                                       id="IFeelJoy4"
                                                                       onChange={this.props.handleChangePageData('IFeelJoy', true)}
                                                                       checked={pageData?.IFeelJoy?.[4]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelJoy4">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="5"
                                                                       id="IFeelJoy5"
                                                                       onChange={this.props.handleChangePageData('IFeelJoy', true)}
                                                                       checked={pageData?.IFeelJoy?.[5]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelJoy5">&nbsp;</label>
                                                            </td>


                                                            <td width="8%" align="center" valign="center"
                                                                className="lightgreen uiheading ">

                                                                <input type="checkbox"
                                                                       name="6"
                                                                       id="IFeelJoy6"
                                                                       onChange={this.props.handleChangePageData('IFeelJoy', true)}
                                                                       checked={pageData?.IFeelJoy?.[6]}/>
                                                                <label className="cursor-pointer" htmlFor="IFeelJoy6">&nbsp;</label>
                                                            </td>


                                                        </tr>


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
        ;
    }
}